import { React, useEffect, useState, useMemo } from "react";
import { getProjects, createProjectPermissionsApi } from "../../services/Api";

import cogoToast from "cogo-toast";
import { SUCCESS_RESULT } from "../../Constants";
import { Badge } from "reactstrap";
import { useHistory, Link } from "react-router-dom";
import { Breadcrumb, BreadcrumbItem, Button } from "reactstrap";
import { FaEdit, FaPlus, FaEye, FaSearch, FaSortUp, FaSortDown, FaKey } from "react-icons/fa";

import ability from '../../pages/config/defineAbility';
import { PERMS } from '../../pages/config/perms'
import BtnSpinner from "../../components/BtnSpinner";

const Projects = (props) => {
  const history = useHistory();

  const [isLoading, setIsLoading] = useState(false);
  const [projects, setProjects] = useState([]);
  const [searchTerm, setSearchTerm] = useState("");
  const [sortField, setSortField] = useState("");
  const [sortDirection, setSortDirection] = useState("asc");
  const [isCreatingPermissions, setIsCreatingPermissions] = useState(false);

  useEffect(() => {
    listProjects();
    return () => { };
  }, []);



   
    


  
  const listProjects = () => {
    setIsLoading(true);

    getProjects()
      .then((res) => {
        setIsLoading(false);
        if (res.status == 200) {
          if (res.data.status == SUCCESS_RESULT) {
             setProjects(res.data.data);
          } else {
            cogoToast.error(res.data.message, {});
          }
        }
      })
      .catch((err) => {
        setIsLoading(false);
        console.log(err);
        cogoToast.error("Something went wrong, please Try again. ", {});
      });
  };

  // Filter and sort projects
  const filteredAndSortedProjects = useMemo(() => {
    let filtered = projects;

    // Apply search filter
    if (searchTerm) {
      filtered = filtered.filter(project =>
        project.project_name?.toLowerCase().includes(searchTerm.toLowerCase()) ||
        project.alias?.toLowerCase().includes(searchTerm.toLowerCase()) ||
        project.project_description?.toLowerCase().includes(searchTerm.toLowerCase()) ||
        project.project_code?.toLowerCase().includes(searchTerm.toLowerCase())
      );
    }

    // Apply sorting
    if (sortField) {
      filtered = [...filtered].sort((a, b) => {
        let aValue = a[sortField];
        let bValue = b[sortField];

        // Handle null/undefined values
        if (aValue == null) aValue = "";
        if (bValue == null) bValue = "";

        // Handle numeric fields
        if (sortField === 'sectors_count' || sortField === 'total_beneficiaries') {
          aValue = Number(aValue) || 0;
          bValue = Number(bValue) || 0;
          return sortDirection === "asc" ? aValue - bValue : bValue - aValue;
        }

        // Handle date fields
        if (sortField === 'startdate' || sortField === 'enddate') {
          aValue = new Date(aValue) || new Date(0);
          bValue = new Date(bValue) || new Date(0);
          return sortDirection === "asc" ? aValue - bValue : bValue - aValue;
        }

        // Convert to string for comparison
        aValue = String(aValue).toLowerCase();
        bValue = String(bValue).toLowerCase();

        if (sortDirection === "asc") {
          return aValue < bValue ? -1 : aValue > bValue ? 1 : 0;
        } else {
          return aValue > bValue ? -1 : aValue < bValue ? 1 : 0;
        }
      });
    }

    return filtered;
  }, [projects, searchTerm, sortField, sortDirection]);

  const handleSort = (field) => {
    if (sortField === field) {
      setSortDirection(sortDirection === "asc" ? "desc" : "asc");
    } else {
      setSortField(field);
      setSortDirection("asc");
    }
  };

  const formatDate = (dateString) => {
    if (!dateString) return '-';
    try {
      const date = new Date(dateString);
      return date.toLocaleDateString('en-US', { year: 'numeric', month: 'short', day: 'numeric' });
    } catch {
      return dateString;
    }
  };

  const handleCreatePermissions = () => {
    setIsCreatingPermissions(true);
    
    createProjectPermissionsApi({})
      .then((res) => {
        setIsCreatingPermissions(false);
        if (res.status === 200) {
          const response = res.data;
          if (response.status === SUCCESS_RESULT) {
            cogoToast.success(response.message || "Project permissions created successfully", {
              hideAfter: 5,
            });
          } else {
            cogoToast.error(response.message || "Failed to create project permissions", {
              hideAfter: 5,
            });
          }
        } else {
          cogoToast.error(res.message || "Failed to create project permissions", {
            hideAfter: 5,
          });
        }
      })
      .catch((err) => {
        setIsCreatingPermissions(false);
        const errorMessage =
          err?.response?.data?.message || "Something went wrong, please try again.";
        cogoToast.error(errorMessage, { hideAfter: 5 });
      });
  };

  return (
    <div style={{ padding: '20px', minHeight: '100vh', backgroundColor: '#f8f9fa' }}>
      <h1 style={{ color: '#333', marginBottom: '20px', fontWeight: '600' }}>PROJECTS</h1>
      <Breadcrumb className="ms-1" style={{ marginBottom: '20px' }}>
        <BreadcrumbItem>
          <Link to="/ebms"> EBMS </Link>
        </BreadcrumbItem>
        <BreadcrumbItem active>
          <Link to="/projects"> PROJECTS </Link>
        </BreadcrumbItem>
      </Breadcrumb>

      <div className="card" style={{ borderRadius: '8px', boxShadow: '0 2px 4px rgba(0,0,0,0.1)' }}>
        <div className="card-body" style={{ padding: '25px' }}>
          {/* Loading Animation */}
          {isLoading && (
            <div style={{
              display: 'flex',
              flexDirection: 'column',
              gap: '20px',
              marginTop: '10px'
            }}>
              {[1, 2, 3].map((index) => (
                <div
                  key={index}
                  style={{
                    backgroundColor: 'white',
                    borderRadius: '12px',
                    padding: '20px',
                    boxShadow: '0 2px 8px rgba(0,0,0,0.1)',
                    border: '1px solid #e0e0e0',
                    display: 'flex',
                    flexDirection: 'row',
                    width: '100%',
                    position: 'relative',
                    overflow: 'hidden',
                    gap: '20px',
                    alignItems: 'center',
                    animation: 'pulse 1.5s ease-in-out infinite'
                  }}
                >
                  {/* Left colored accent bar */}
                  <div style={{
                    position: 'absolute',
                    top: 0,
                    left: 0,
                    bottom: 0,
                    width: '4px',
                    background: 'linear-gradient(180deg, #2196f3, #42a5f5)'
                  }} />

                  {/* Main Content Area - Skeleton */}
                  <div style={{
                    flex: 1,
                    display: 'flex',
                    flexDirection: 'column',
                    gap: '12px',
                    paddingLeft: '8px',
                    minWidth: 0
                  }}>
                    {/* Title Skeleton */}
                    <div style={{
                      height: '28px',
                      width: '60%',
                      backgroundColor: '#e0e0e0',
                      borderRadius: '6px',
                      animation: 'shimmer 1.5s ease-in-out infinite'
                    }} />

                    {/* Alias/Code Skeleton */}
                    <div style={{ 
                      display: 'flex', 
                      gap: '20px',
                      flexWrap: 'wrap'
                    }}>
                      <div style={{
                        height: '40px',
                        width: '120px',
                        backgroundColor: '#e0e0e0',
                        borderRadius: '6px',
                        animation: 'shimmer 1.5s ease-in-out infinite',
                        animationDelay: '0.2s'
                      }} />
                      <div style={{
                        height: '40px',
                        width: '150px',
                        backgroundColor: '#e0e0e0',
                        borderRadius: '6px',
                        animation: 'shimmer 1.5s ease-in-out infinite',
                        animationDelay: '0.4s'
                      }} />
                    </div>

                    {/* Description Skeleton */}
                    <div style={{
                      height: '16px',
                      width: '90%',
                      backgroundColor: '#e0e0e0',
                      borderRadius: '4px',
                      animation: 'shimmer 1.5s ease-in-out infinite',
                      animationDelay: '0.6s'
                    }} />
                    <div style={{
                      height: '16px',
                      width: '70%',
                      backgroundColor: '#e0e0e0',
                      borderRadius: '4px',
                      animation: 'shimmer 1.5s ease-in-out infinite',
                      animationDelay: '0.8s'
                    }} />

                    {/* Stats and Dates Skeleton */}
                    <div style={{
                      display: 'flex',
                      gap: '20px',
                      alignItems: 'center',
                      flexWrap: 'wrap',
                      marginTop: '8px'
                    }}>
                      <div style={{
                        height: '32px',
                        width: '100px',
                        backgroundColor: '#e0e0e0',
                        borderRadius: '20px',
                        animation: 'shimmer 1.5s ease-in-out infinite',
                        animationDelay: '1s'
                      }} />
                      <div style={{
                        height: '40px',
                        width: '120px',
                        backgroundColor: '#e0e0e0',
                        borderRadius: '6px',
                        animation: 'shimmer 1.5s ease-in-out infinite',
                        animationDelay: '1.2s'
                      }} />
                    </div>
      </div>

                  {/* Right Side - Action Buttons Skeleton */}
                  <div style={{
                    display: 'flex',
                    flexDirection: 'column',
                    gap: '8px',
                    alignItems: 'stretch',
                    minWidth: '120px',
                    paddingLeft: '20px',
                    borderLeft: '1px solid #f0f0f0'
                  }}>
                    <div style={{
                      height: '38px',
                      width: '100%',
                      backgroundColor: '#e0e0e0',
                      borderRadius: '6px',
                      animation: 'shimmer 1.5s ease-in-out infinite',
                      animationDelay: '1.4s'
                    }} />
                    <div style={{
                      height: '38px',
                      width: '100%',
                      backgroundColor: '#e0e0e0',
                      borderRadius: '6px',
                      animation: 'shimmer 1.5s ease-in-out infinite',
                      animationDelay: '1.6s'
                    }} />
                  </div>
                </div>
              ))}
            </div>
          )}

          {/* Add CSS Animations */}
          <style>{`
            @keyframes pulse {
              0%, 100% {
                opacity: 1;
              }
              50% {
                opacity: 0.6;
              }
            }
            @keyframes shimmer {
              0% {
                background-color: #e0e0e0;
              }
              50% {
                background-color: #f5f5f5;
              }
              100% {
                background-color: #e0e0e0;
              }
            }
          `}</style>
          {/* Header with Create Button and Search - Only show when not loading */}
          {!isLoading && (
            <>
          <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '20px', flexWrap: 'wrap', gap: '15px' }}>
            <div style={{ display: 'flex', gap: '10px', flexWrap: 'wrap' }}>
              {ability.can(PERMS.CREATE, PERMS.CREATE_PROJECT) && (
                <Button
                  className="btn btn-info"
                  onClick={() => {
                    history.push({
                      pathname: "/projects/create",
                      state: {},
                    });
                  }}
                  style={{ 
                    borderRadius: '6px',
                    padding: '10px 20px',
                    fontWeight: '500'
                  }}
                >
                  <FaPlus style={{ marginRight: '8px' }} />
                  CREATE NEW PROJECT
                </Button>
              )}
              {isCreatingPermissions ? (
                <BtnSpinner
                  is_loading={true}
                  text="Creating Permissions..."
                  color="white"
                  class="btn btn-warning"
                  size="5"
                />
              ) : (
                <Button
                  className="btn btn-warning"
                  onClick={handleCreatePermissions}
                  style={{ 
                    borderRadius: '6px',
                    padding: '10px 20px',
                    fontWeight: '500',
                    background: 'linear-gradient(135deg, #f093fb 0%, #f5576c 100%)',
                    border: 'none',
                    color: 'white'
                  }}
                >
                  <FaKey style={{ marginRight: '8px' }} />
                  CREATE PERMISSIONS
                </Button>
              )}
            </div>
            
            {/* Search Box */}
            <div style={{ position: 'relative', flex: '1', maxWidth: '400px', minWidth: '250px' }}>
              <FaSearch 
                style={{ 
                  position: 'absolute', 
                  left: '15px', 
                  top: '50%', 
                  transform: 'translateY(-50%)', 
                  color: '#999',
                  fontSize: '14px'
                }} 
              />
              <input
                type="text"
                placeholder="Search projects by name, alias, code, or description..."
                value={searchTerm}
                onChange={(e) => setSearchTerm(e.target.value)}
                style={{
                  width: '100%',
                  padding: '12px 15px 12px 40px',
                  border: '1px solid #ddd',
                  borderRadius: '25px',
                  fontSize: '14px',
                  outline: 'none',
                  boxShadow: '0 2px 4px rgba(0, 0, 0, 0.05)',
                  transition: 'all 0.3s ease'
                }}
                onFocus={(e) => {
                  e.target.style.borderColor = '#2196f3';
                  e.target.style.boxShadow = '0 2px 8px rgba(33, 150, 243, 0.2)';
                }}
                onBlur={(e) => {
                  e.target.style.borderColor = '#ddd';
                  e.target.style.boxShadow = '0 2px 4px rgba(0, 0, 0, 0.05)';
                }}
              />
            </div>
          </div>

          {/* Results Count and Sort Options */}
          <div style={{ 
            display: 'flex', 
            justifyContent: 'space-between', 
            alignItems: 'center', 
            marginBottom: '20px', 
            flexWrap: 'wrap',
            gap: '10px'
          }}>
            <div style={{ color: '#666', fontSize: '14px' }}>
              Showing <strong>{filteredAndSortedProjects.length}</strong> of <strong>{projects.length}</strong> project(s)
              {searchTerm && (
                <span style={{ marginLeft: '10px', color: '#2196f3' }}>
                  (filtered by "{searchTerm}")
                </span>
              )}
            </div>
            <div style={{ display: 'flex', gap: '10px', alignItems: 'center', flexWrap: 'wrap' }}>
              <span style={{ fontSize: '13px', color: '#666' }}>Sort by:</span>
              <select
                value={sortField}
                onChange={(e) => {
                  if (e.target.value) {
                    handleSort(e.target.value);
                  } else {
                    setSortField("");
                  }
                }}
                style={{
                  padding: '6px 12px',
                  borderRadius: '6px',
                  border: '1px solid #ddd',
                  fontSize: '13px',
                  outline: 'none',
                  cursor: 'pointer'
                }}
              >
                <option value="">None</option>
                <option value="project_name">Project Name</option>
                <option value="alias">Alias</option>
                <option value="project_code">Project Code</option>
                <option value="sectors_count">Sectors</option>
                <option value="total_beneficiaries">Beneficiaries</option>
                <option value="startdate">Start Date</option>
                <option value="enddate">End Date</option>
              </select>
              {sortField && (
                <button
                  onClick={() => setSortDirection(sortDirection === "asc" ? "desc" : "asc")}
                  style={{
                    padding: '6px 10px',
                    borderRadius: '6px',
                    border: '1px solid #ddd',
                    backgroundColor: 'white',
                    cursor: 'pointer',
                    fontSize: '13px',
                    display: 'flex',
                    alignItems: 'center',
                    gap: '5px'
                  }}
                  title={`Sort ${sortDirection === "asc" ? "Descending" : "Ascending"}`}
                >
                  {sortDirection === "asc" ? <FaSortUp /> : <FaSortDown />}
                  {sortDirection === "asc" ? "Asc" : "Desc"}
                       </button>
  )}
            </div>
          </div>

          {/* Project Cards Grid */}
          {filteredAndSortedProjects.length === 0 ? (
            <div style={{ 
              textAlign: 'center', 
              padding: '60px 20px', 
              color: '#999',
              backgroundColor: '#f9f9f9',
              borderRadius: '8px',
              border: '2px dashed #ddd'
            }}>
              <div style={{ fontSize: '48px', marginBottom: '15px', opacity: 0.5 }}>📋</div>
              <div style={{ fontSize: '18px', fontWeight: '500', marginBottom: '8px' }}>
                {searchTerm ? 'No projects found' : 'No projects available'}
              </div>
              <div style={{ fontSize: '14px' }}>
                {searchTerm 
                  ? 'Try adjusting your search terms' 
                  : 'Create a new project to get started'}
              </div>
            </div>
          ) : (
            <div style={{
              display: 'flex',
              flexDirection: 'column',
              gap: '20px',
              marginTop: '10px'
            }}>
              {filteredAndSortedProjects.map((project, index) => (
                <div
                  key={project.id || index}
                  onClick={() => {
                     history.push({
                      pathname: `/projects/details/${project.id}`,
                      state: { project },
                    });
                  }}
                  style={{
                    backgroundColor: 'white',
                    borderRadius: '12px',
                    padding: '20px',
                    boxShadow: '0 2px 8px rgba(0,0,0,0.1)',
                    border: '1px solid #e0e0e0',
                    cursor: 'pointer',
                    transition: 'all 0.3s ease',
                    display: 'flex',
                    flexDirection: 'row',
                    width: '100%',
                    position: 'relative',
                    overflow: 'hidden',
                    gap: '20px',
                    alignItems: 'center'
                  }}
                  onMouseEnter={(e) => {
                    e.currentTarget.style.transform = 'translateX(4px)';
                    e.currentTarget.style.boxShadow = '0 4px 16px rgba(0,0,0,0.15)';
                    e.currentTarget.style.borderColor = '#2196f3';
                  }}
                  onMouseLeave={(e) => {
                    e.currentTarget.style.transform = 'translateX(0)';
                    e.currentTarget.style.boxShadow = '0 2px 8px rgba(0,0,0,0.1)';
                    e.currentTarget.style.borderColor = '#e0e0e0';
                  }}
                >
                  {/* Left colored accent bar */}
                  <div style={{
                    position: 'absolute',
                    top: 0,
                    left: 0,
                    bottom: 0,
                    width: '4px',
                    background: 'linear-gradient(180deg, #2196f3, #42a5f5)'
                  }} />

                  {/* Main Content Area */}
                  <div style={{
                    flex: 1,
                    display: 'flex',
                    flexDirection: 'column',
                    gap: '12px',
                    paddingLeft: '8px',
                    minWidth: 0
                  }}>
                    {/* Project Name and Basic Info */}
                    <div>
                      <h3 style={{
                        margin: '0 0 8px 0',
                        color: '#333',
                        fontSize: '22px',
                        fontWeight: '600',
                        lineHeight: '1.3'
                      }}>
                        {project.project_name || 'Unnamed Project'}
                      </h3>
                      <div style={{ 
                        display: 'flex', 
                        gap: '20px',
                        flexWrap: 'wrap',
                        alignItems: 'center'
                      }}>
                        {project.alias && (
                          <div>
                            <span style={{ fontSize: '11px', color: '#999', textTransform: 'uppercase', display: 'block', marginBottom: '2px' }}>Alias</span>
                            <span style={{ fontSize: '14px', color: '#666', fontWeight: '500' }}>
                              {project.alias}
                            </span>
                          </div>
                        )}
                        {project.project_code && (
                          <div>
                            <span style={{ fontSize: '11px', color: '#999', textTransform: 'uppercase', display: 'block', marginBottom: '2px' }}>Code</span>
                            <span style={{ fontSize: '14px', color: '#666', fontWeight: '500' }}>
                              {project.project_code}
                            </span>
                          </div>
                        )}
                      </div>
                    </div>

                    {/* Description */}
                    {project.project_description && (
                      <div style={{ 
                        flex: 1,
                        minWidth: 0
                      }}>
                        <p style={{
                          fontSize: '14px',
                          color: '#666',
                          lineHeight: '1.5',
                          margin: 0,
                          display: '-webkit-box',
                          WebkitLineClamp: 2,
                          WebkitBoxOrient: 'vertical',
                          overflow: 'hidden',
                          textOverflow: 'ellipsis'
                        }}>
                          {project.project_description}
                        </p>
                      </div>
                    )}

                    {/* Stats and Dates Row */}
                    <div style={{
                      display: 'flex',
                      gap: '20px',
                      alignItems: 'center',
                      flexWrap: 'wrap'
                    }}>
                      <Badge 
                        color="info" 
                        style={{ 
                          padding: '8px 16px', 
                          borderRadius: '20px',
                          fontSize: '13px',
                          fontWeight: '500',
                          color: 'white'
                        }}
                      >
                        {project.sectors_count || 0} Sectors
                      </Badge>
                      <div style={{
                        display: 'flex',
                        gap: '20px',
                        fontSize: '12px',
                        color: '#999',
                        flexWrap: 'wrap'
                      }}>
                        <div>
                          <span style={{ display: 'block', marginBottom: '2px' }}>Start Date</span>
                          <span style={{ color: '#666', fontWeight: '500' }}>
                            {formatDate(project.startdate)}
                          </span>
                        </div>
                        <div>
                          <span style={{ display: 'block', marginBottom: '2px' }}>End Date</span>
                          <span style={{ color: '#666', fontWeight: '500' }}>
                            {formatDate(project.enddate)}
                          </span>
                        </div>
                      </div>
                    </div>
                  </div>

                  {/* Right Side - Action Buttons */}
                  <div style={{
                    display: 'flex',
                    flexDirection: 'column',
                    gap: '8px',
                    alignItems: 'stretch',
                    minWidth: '120px',
                    paddingLeft: '20px',
                    borderLeft: '1px solid #f0f0f0'
                  }}>
                    {ability.can(PERMS.UPDATE, PERMS.UPDATE_PROJECT) && (
                      <button
                        className="btn btn-sm btn-primary"
                        onClick={(e) => {
                          e.stopPropagation();
                          history.push({
                            pathname: "/projects/create",
                            state: { data: project },
                          });
                        }}
                          style={{
                          borderRadius: '6px',
                          padding: '10px 16px',
                          display: 'flex',
                          alignItems: 'center',
                          justifyContent: 'center',
                          gap: '6px',
                          fontSize: '13px',
                          fontWeight: '500',
                          whiteSpace: 'nowrap'
                        }}
                        title="Edit Project"
                      >
                        <FaEdit /> Edit
                      </button>
                    )}
                    <button
                      className="btn btn-sm btn-success"
                      onClick={(e) => {
                        e.stopPropagation();
                             history.push({
                              pathname: `/projects/details/${project.id}`,
                          state: { project },
                            });
                          }}
                      style={{
                        borderRadius: '6px',
                        padding: '10px 16px',
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'center',
                        gap: '6px',
                        fontSize: '13px',
                        fontWeight: '500',
                        whiteSpace: 'nowrap'
                      }}
                      title="View Project"
                    >
                      <FaEye /> View
                    </button>
                  </div>
                </div>
              ))}
            </div>
          )}
            </>
          )}
        </div>
      </div>
    </div>
  );
};

export default Projects;
